import { useEffect } from 'react'
import QuestionKey from '../../../Questions/question-key'
import { Action } from '../../ApplicationForm/ApplicationFormContext'
import { handlePrevButtonClick } from '../utils'
import { HistoryState } from './HistoryContext'
import HistoryEntry from './HistoryEntry'

/**
 * Generic handler for History state escape actions
 */
export const useEscapeAction = <EntryType extends HistoryEntry>(
  appFormContextDispatch : (action: Action) => void,
  state : HistoryState<EntryType>,
  questionKey : QuestionKey
): void => {
  useEffect(() => {
    switch (state.escapeAction) {
      case 'NEXT': {
        appFormContextDispatch({
          type: 'QUESTION_ANSWERED',
          name: questionKey,
          value: {
            entries: state.entries
          }
        })
        break
      }
      case 'PREVIOUS': {
        handlePrevButtonClick(
          appFormContextDispatch,
          {
            name: questionKey,
            value: { entries: state.entries }
          }
        )
        break
      }
      default:
        break
    }
  }, [state.escapeAction])
}
